import ErrorEntities from '@/models/error-entities'

import { AuthMutationTypes } from '@/store/modules/auth/AuthMutationTypes'

export interface State {
  errors: ErrorEntities
  pending: boolean
}

const initialState: State = {
  errors: {},
  pending: false,
}

export default {
  state: initialState,
  getters: {
    getRegistrationPageErrors(state: State): ErrorEntities {
      return state.errors
    },
    getRegistrationPagePending(state: State): boolean {
      return state.pending
    },
  },
  mutations: {
    [AuthMutationTypes.Registration](state: State) {
      state.pending = true
      state.errors = {}
    },
    [AuthMutationTypes.RegistrationSuccess](state: State) {
      state.pending = false
      state.errors = {}
    },
    [AuthMutationTypes.RegistrationFailure](
      state: State,
      errors: ErrorEntities,
    ) {
      state.pending = false
      state.errors = errors
    },
  },
}
